import React from 'react';

const Pagination = ({ nextPageToken, onNext }) => nextPageToken ? (
    <div className="d-flex justify-content-center">
        <button className="btn btn-secondary btn-block mr-2" onClick={onNext}>Load More</button>
    </div>
) : null;

export default Pagination;